module.exports = __webpack_public_path__ + "static/media/shopping_cart.e4bffb46.jpeg";